import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGlobalPpis } from '../actions';
import { getGlobalPpisWithStatus, getIsFetchingGlobal } from '../selectors';
import { getIsLocalUser } from '../../loginSystem/selectors';

const useGlobalPpis = ({ status = null } = {}) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetchingGlobal);
  const globalPpis = useSelector(getGlobalPpisWithStatus(status));
  const isLocalUser = useSelector(getIsLocalUser);

  useEffect(() => {
    // Only fetch global dishes if context user is local user (service office)
    if (isLocalUser) {
      dispatch(fetchGlobalPpis());
    }
  }, [dispatch, isLocalUser]);

  return [isFetching, globalPpis];
};

export default useGlobalPpis;
